// material-ui
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

// project imports
import IconButton from '@/components/@extended/IconButton';
import BugOutlined from '@ant-design/icons/BugOutlined';
import { useErrorContext } from '@/providers/error-boundary/context';
import { showErrorLog } from '@/env.config';

// ==============================|| HEADER - BUTON JURNAL ERORI (DEV) ||============================== //
// Vizibil DOAR când VITE_SHOW_ERROR_LOG=true (mediu de dev). Deschide ErrorDetailsDialog cu
// jurnalul sesiunii din pipeline-ul global de erori (badge = nr. de erori înregistrate).

export default function DevErrorLogButton() {
	const { entries, openDialog } = useErrorContext();

	if (!showErrorLog) return null;

	return (
		<Box sx={{ flexShrink: 0 }}>
			<Tooltip title="Jurnal erori (dev)">
				<IconButton
					color="secondary"
					variant="light"
					aria-label="deschide jurnalul de erori"
					sx={{ color: 'text.primary' }}
					onClick={() => openDialog()}
				>
					<Badge badgeContent={entries.length > 99 ? '99+' : entries.length} color="error">
						<BugOutlined />
					</Badge>
				</IconButton>
			</Tooltip>
		</Box>
	);
}
